"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _models = require("@seedlang/models");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TriviaCardWrapper = function TriviaCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "opponentTurn", _descriptor, _this);
      _initializerDefineProperty(_this, "myTurn", _descriptor2, _this);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor3, _this);
      _initializerDefineProperty(_this, "toggledSentenceType", _descriptor4, _this);
      _initializerDefineProperty(_this, "bothScoresSubmitted", _descriptor5, _this);
      _initializerDefineProperty(_this, "userCardUpdatedAt", _descriptor6, _this);
      _initializerDefineProperty(_this, "correct", _descriptor7, _this);
      _initializerDefineProperty(_this, "timerStartedAt", _descriptor8, _this);
      _initializerDefineProperty(_this, "lastLocalUpdatedAt", _descriptor9, _this);
      _initializerDefineProperty(_this, "initialVideoPlayFinished", _descriptor10, _this);
      _state.DeckUI.enrichSentence(_this.props.card);
      _this.myTurn = new _models.PlayerTurn(_this, false);
      _this.opponentTurn = new _models.PlayerTurn(_this, false);
      _this.opponentTurn.set('pastPerformance', _this.pastPerformance);
      _this.lastLocalUpdatedAt = _this.props.userCard.localUpdatedAt;
      _this.disposer = (0, _mobx.autorun)(function () {
        if (_state.DeckUI.reviewDeck && _this.props.inView && _this.props.userCard.localUpdatedAt !== _this.lastLocalUpdatedAt && _state.DeckUI.userDeck.numActiveUserCards === 2) {
          _this.lastLocalUpdatedAt = _this.props.userCard.localUpdatedAt;
          _this.onReset();
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.disposer && this.disposer();
        clearInterval(this.interval);
        this.stopTimer();
      }
    }, {
      key: "hasOpponent",
      get: function get() {
        return (0, _utils.isPresent)(this.opponentUserDeck);
      }
    }, {
      key: "opponentUserDeck",
      get: function get() {
        return _state.DeckUI.userDeck && _state.DeckUI.userDeck.opponentUserDeck;
      }
    }, {
      key: "opponent",
      get: function get() {
        return this.hasOpponent ? this.opponentUserDeck.user : null;
      }
    }, {
      key: "opponentPoints",
      get: function get() {
        var _this2 = this;
        if (this.hasOpponent && this.opponentTurn.pastPerformance && _state.DeckUI.userDeck) {
          var points = _state.DeckUI.userDeck.opponentUserDeck.userCards.filter(function (item) {
            return item.position < _this2.props.userCard.position;
          }).map(function (item) {
            return item.points;
          }).reduce(function (a, b) {
            return a + b;
          }, 0);
          points = this.props.userCard && this.props.userCard.seen ? points + this.opponentTurn.pastPerformance.points : points + this.opponentTurn.points;
          return points > _state.DeckUI.userDeck.opponentUserDeck.points ? _state.DeckUI.userDeck.opponentUserDeck.points : points;
        }
      }
    }, {
      key: "borderColor",
      get: function get() {
        if (this.myTurn.correct) {
          return _constants.Theme.green;
        } else if (this.myTurn.correct === false) {
          return _constants.Theme.red;
        } else {
          return '#565656';
        }
      }
    }, {
      key: "questionVideoClip",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.targetVideoClip;
      }
    }, {
      key: "correctAnswerVideoClip",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.answer.correctVideoClip;
      }
    }, {
      key: "incorrectAnswerVideoClip",
      get: function get() {
        return this.props.card && this.props.card.sentence && this.props.card.sentence.answer.incorrectVideoClip;
      }
    }, {
      key: "videoClipType",
      get: function get() {
        if (this.sentenceType === 'answer' && this.showSentence && this.props.userCard.correct) {
          return 'correct-answer';
        }
        if (this.sentenceType === 'answer' && this.showSentence && this.props.userCard.correct === false) {
          return 'incorrect-answer';
        } else {
          return 'question';
        }
      }
    }, {
      key: "pastPerformance",
      get: function get() {
        if (this.hasOpponent && _state.DeckUI.userDeck && (0, _utils.isPresent)(_state.DeckUI.deck.cards)) {
          var cardIndex = _state.DeckUI.deck.cards.map(function (item) {
            return item.id;
          }).indexOf(this.props.card.id);
          if (_state.DeckUI.userDeck.opponentUserDeck.userCards.length >= cardIndex) {
            return _state.DeckUI.userDeck.opponentUserDeck.userCards[cardIndex];
          }
        }
      }
    }, {
      key: "timerActive",
      get: function get() {
        return this.myTurn.timerActive || this.opponentTurn.timerActive;
      }
    }, {
      key: "opponentInactive",
      get: function get() {
        return !this.hasOpponent || this.opponentTurn.timerStoppedAt;
      }
    }, {
      key: "sentenceType",
      get: function get() {
        return this.showSentence ? this.toggledSentenceType : 'question';
      }
    }, {
      key: "questionOrAnswer",
      get: function get() {
        return this.sentenceType === 'answer' && this.props.card.sentence && this.props.card.sentence.answer ? this.props.card.sentence.answer : this.props.card.sentence;
      }
    }, {
      key: "sentence",
      get: function get() {
        return (0, _utils.isPresent)(this.props.card) ? this.questionOrAnswer : {};
      }
    }, {
      key: "showSentence",
      get: function get() {
        return this.bothScoresSubmitted || !_state.DeckUI.reviewDeck && this.props.userCard.seen && this.props.userCard.timerInitiated;
      }
    }, {
      key: "showWordCard",
      get: function get() {
        return this.props.inView && this.sentence.state && this.sentence.selectedWordAssociation;
      }
    }, {
      key: "icons",
      get: function get() {
        return ['cardComments', 'toggleReview', 'languageButton'];
      }
    }, {
      key: "reviewIcons",
      get: function get() {
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "afterInitialPlay",
      value: function afterInitialPlay() {
        this.initialVideoPlayFinished = true;
        if (!this.props.userCard.timerInitiated || _state.DeckUI.reviewDeck) {
          this.initiateTimer();
        }
      }
    }, {
      key: "initiateTimer",
      value: function initiateTimer() {
        _state.DeckUI.userCardStore.update({
          ids: {
            userCardId: this.props.userCard.id
          },
          data: {
            timer_initiated: true,
            seen: true
          }
        }, _lodash.noop);
        this.props.userCard.set('timerInitiated', true);
        if (!_state.DeckUI.reviewDeck) {
          _state.AppUI.soundEffectStore.play('countDown');
        }
        var timerStartedAt = +new Date();
        this.opponentTurn.initiateTimer(timerStartedAt);
        this.myTurn.initiateTimer(timerStartedAt);
        this.interval = setInterval(this.decrementTimer.bind(this), _constants.Constants.TRIVIA_TIMER_INTERVAL);
      }
    }, {
      key: "timeOut",
      value: function timeOut() {
        this.answerSelected(false);
        _state.DeckUI.reveal(this.props.card, this.props.cardState);
        _state.DeckUI.onIncorrectAnswer();
      }
    }, {
      key: "onCorrectOpponentTurn",
      value: function onCorrectOpponentTurn() {
        _state.AppUI.soundEffectStore.play('correctOpponent');
        if (this.myTurn.timerStoppedAt) {
          this.setBothScoresSubmitted();
        }
      }
    }, {
      key: "onIncorrectOpponentTurn",
      value: function onIncorrectOpponentTurn() {
        _state.AppUI.soundEffectStore.play('failureOpponent');
        if (this.myTurn.timerStoppedAt) {
          this.setBothScoresSubmitted();
        }
      }
    }, {
      key: "onToggleSentenceType",
      value: function onToggleSentenceType() {
        this.sentence.state.onReset();
        this.toggledSentenceType = !this.toggledSentenceType || this.toggledSentenceType === 'answer' ? 'question' : 'answer';
      }
    }, {
      key: "clearSelection",
      value: function clearSelection() {
        this.multipleChoiceSelected = null;
      }
    }, {
      key: "onClick",
      value: function onClick(option) {
        var _this3 = this;
        if (!this.myTurn.timerStoppedAt) {
          option.set('selectedCount', option.selectedCount + 1);
          this.multipleChoiceSelected = option.id;
          this.answerSelected(option.correct);
          if (option.correct) {
            this.props.userCard.set('points', this.myTurn.points);
            this.props.userCard.set('pointsSubmitted', true);
            _state.DeckUI.userDeck.calculatePoints();
            _state.DeckUI.onCorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, {
              xp: 2,
              xpSlug: 'trivia',
              points: this.myTurn.points,
              multipleChoiceOptionId: option.id,
              secondsElapsed: this.myTurn.secondsElapsed
            });
          } else {
            _state.DeckUI.onIncorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, {
              multipleChoiceOptionId: option.id,
              secondsElapsed: this.myTurn.secondsElapsed
            });
          }
          this.correct = option.correct;
          setTimeout(function () {
            return _state.DeckUI.reveal(_this3.props.card, _this3.props.cardState, _this3.props.userCard);
          }, 500);
        }
      }
    }, {
      key: "setBothScoresSubmitted",
      value: function setBothScoresSubmitted() {
        var _this4 = this;
        _state.AppUI.soundEffectStore.pause('countDown');
        setTimeout(function () {
          return _this4.setBothScoresSubmittedDelayed();
        }, 500);
      }
    }, {
      key: "setBothScoresSubmittedDelayed",
      value: function setBothScoresSubmittedDelayed() {
        this.bothScoresSubmitted = true;
        this.props.userCard.set('seen', true);
      }
    }, {
      key: "answerSelected",
      value: function answerSelected(correct) {
        this.correct = correct;
        this.myTurn.stopTimer(correct);
        if (this.opponentInactive) {
          this.setBothScoresSubmitted();
        }
      }
    }, {
      key: "stopTimer",
      value: function stopTimer() {
        clearInterval(this.interval);
        this.opponentTurn.stopTimer();
        this.myTurn.stopTimer();
      }
    }, {
      key: "decrementTimer",
      value: function decrementTimer() {
        this.myTurn.updateTimerProgress();
        this.opponentTurn.updateTimerProgress();
        if (!this.myTurn.timerActive && this.opponentInactive) {
          this.stopTimer();
        }
      }
    }, {
      key: "onReset",
      value: function onReset() {
        this.multipleChoiceSelected = null;
        this.toggledSentenceType = 'answer';
        this.bothScoresSubmitted = false;
        this.userCardUpdatedAt = null;
        this.correct = null;
        this.timerStartedAt = null;
        this.myTurn = new _models.PlayerTurn(this, false);
        this.opponentTurn = new _models.PlayerTurn(this, false);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          sentence: this.sentence,
          borderColor: this.borderColor,
          afterInitialPlay: this.afterInitialPlay,
          videoClip: this.videoClip,
          questionVideoClip: this.questionVideoClip,
          correctAnswerVideoClip: this.correctAnswerVideoClip,
          incorrectAnswerVideoClip: this.incorrectAnswerVideoClip,
          videoClipType: this.videoClipType,
          showSentence: this.showSentence,
          onToggleSentenceType: this.onToggleSentenceType,
          sentenceType: this.sentenceType,
          onClick: this.onClick,
          multipleChoiceSelected: this.multipleChoiceSelected,
          opponentTurn: this.opponentTurn,
          myTurn: this.myTurn,
          opponentPoints: this.opponentPoints,
          hasOpponent: this.hasOpponent,
          opponent: this.opponent,
          showWordCard: this.showWordCard,
          correct: this.correct,
          initialVideoPlayFinished: this.initialVideoPlayFinished,
          reviewIcons: this.reviewIcons,
          icons: this.icons
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "opponentTurn", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "myTurn", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "toggledSentenceType", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 'answer';
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "bothScoresSubmitted", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "userCardUpdatedAt", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "timerStartedAt", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "lastLocalUpdatedAt", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "initialVideoPlayFinished", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "hasOpponent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasOpponent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponentUserDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponentUserDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponentPoints", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponentPoints"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "borderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "borderColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "questionVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "questionVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "incorrectAnswerVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "incorrectAnswerVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoClipType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoClipType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pastPerformance", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pastPerformance"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "timerActive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "timerActive"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "opponentInactive", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "opponentInactive"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentenceType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentenceType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "questionOrAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "questionOrAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showWordCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showWordCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "reviewIcons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "reviewIcons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterInitialPlay", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterInitialPlay"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "initiateTimer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "initiateTimer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "timeOut", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "timeOut"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCorrectOpponentTurn", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCorrectOpponentTurn"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onIncorrectOpponentTurn", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onIncorrectOpponentTurn"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleSentenceType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleSentenceType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearSelection", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearSelection"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClick", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClick"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setBothScoresSubmitted", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setBothScoresSubmitted"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setBothScoresSubmittedDelayed", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setBothScoresSubmittedDelayed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "answerSelected", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "answerSelected"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stopTimer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "stopTimer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "decrementTimer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "decrementTimer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onReset"), _class2.prototype), _class2)) || _class;
};
TriviaCardWrapper.displayName = 'TriviaCardWrapper';
var _default = exports["default"] = TriviaCardWrapper;